import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

/** Stages the scan upload moves through, mirrored by the backend `stage` field. */
export const SCAN_UPLOAD_STAGES = [
  { key: "uploading", label: "Uploading", icon: CloudUploadIcon },
  { key: "processing", label: "Reading Answers", icon: FactCheckIcon },
  { key: "grading", label: "Marking", icon: AssignmentTurnedInIcon },
  { key: "complete", label: "Complete", icon: CheckCircleIcon },
];

export const ACCEPTED_SCAN_MIME = ["application/pdf", "image/png", "image/jpeg"];

export const ACCEPTED_SCAN_EXT = /\.(pdf|png|jpe?g)$/i;

export const isAcceptedScanFile = (file) => {
  if (!file) return false;
  if (ACCEPTED_SCAN_MIME.includes(file.type)) return true;
  return ACCEPTED_SCAN_EXT.test(file.name || "");
};
